import { useState } from "react";

import { Paragraph, Small } from "@fronterahealth/frontera-ui-components";

import { UploadBhtiaFile } from "@components/CreateNewClientDialog/UploadBhtiaFile";

enum ClientCreationId {
  BHTIA = "bhtia",
  Manual = "manual",
}

interface NewClientTabProps {
  setLearnerId: (learnerId: string | undefined) => void;
  setOperationsDisabled: (disabled: boolean) => void;
  setLearnerFileId: (learnerFileId: string | undefined) => void;
}

export const NewClientTab: React.FC<NewClientTabProps> = ({
  setLearnerId,
  setOperationsDisabled,
  setLearnerFileId,
}) => {
  const [selectedCreationOption, setSelectedClientOption] = useState<ClientCreationId>(ClientCreationId.BHTIA);
  const selectManualCreation = () => {
    setSelectedClientOption(ClientCreationId.Manual);
    setLearnerId(undefined);
    setOperationsDisabled(false);
    setLearnerFileId(undefined);
  };
  const selectCreationViaBhtia = () => {
    setSelectedClientOption(ClientCreationId.BHTIA);
    setOperationsDisabled(true);
  };

  return (
    <div className="flex flex-col gap-4">
      <div
        key={ClientCreationId.BHTIA}
        className={`border-2 p-4 rounded-lg flex justify-between items-center cursor-pointer transition-all ${
          selectedCreationOption === ClientCreationId.BHTIA ? "border-hatch-500" : "border-gray-300"
        }`}
        onClick={selectCreationViaBhtia}
      >
        <div className="flex flex-col gap-3">
          <Small displayType="loud" colorType="primary">
            Upload BHTSF File
          </Small>
          <Paragraph size="small" colorType="primary">
            Import a BHTSF file to prefill the client’s details automatically. Ideal for clients who have already
            completed intake.
          </Paragraph>
          <UploadBhtiaFile
            setLearnerId={setLearnerId}
            disabled={selectedCreationOption !== ClientCreationId.BHTIA}
            fileUploadedCallback={() => setOperationsDisabled(false)}
            setLearnerFileId={setLearnerFileId}
          />
        </div>
        <input
          type="radio"
          name="clientType"
          value={ClientCreationId.BHTIA}
          checked={selectedCreationOption === ClientCreationId.BHTIA}
          onChange={selectCreationViaBhtia}
          className="w-5 h-5 text-primary checked:ring-0 focus:ring-0 ml-3"
        />
      </div>

      <label
        key={ClientCreationId.Manual}
        className={`border-2 p-4 rounded-lg flex justify-between items-center cursor-pointer transition-all ${
          selectedCreationOption === ClientCreationId.Manual ? "border-hatch-500" : "border-gray-300"
        }`}
      >
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <Small displayType="loud" colorType="primary">
              Enter Manually
            </Small>
            <Paragraph size="small" colorType="primary">
              Type in the client’s information by hand. Best for quick entries or when a BHTSF file isn't available.
            </Paragraph>
          </div>
        </div>
        <input
          type="radio"
          name="clientType"
          value={ClientCreationId.Manual}
          checked={selectedCreationOption === ClientCreationId.Manual}
          onChange={selectManualCreation}
          className="w-5 h-5 text-primary checked:ring-0 focus:ring-0 ml-3"
        />
      </label>
    </div>
  );
};
